<!-- 分区计量-统计分析-片区流量统计 -->
<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div>
    <!-- 查询区域 -->
    <a-card :bordered="false" class="search-card">
      <div class="table-page-search-wrapper">
        <a-form layout="horizontal" :labelCol="{ span: 5 }" :wrapperCol="{ span: 16 }">
          <a-row :gutter="48">
            <!-- 第一排 -->
            <a-col :md="6" :sm="12">
              <a-form-item label="片区选择">
                <a-tree-select :tree-data="zoneTreeData" v-model="query.zoneId" style="width: 100%"
                  :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear
                  :treeDefaultExpandedKeys="treeDefaultExpandedKeys" show-search treeNodeFilterProp="title"
                  @change="handleZoneChange"></a-tree-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="查询时间">
                <a-date-picker v-model="query.queryDate" style="width: 100%" format="YYYY-MM-DD" placeholder="请选择日期"
                  :disabled-date="disabledDate" @change="handleTimeChange" allow-clear />
              </a-form-item>
            </a-col>
            <!-- 第二排-操作按钮 -->
            <a-col :md="24" :sm="24">
              <div style="margin-bottom: 0; display: flex;">
                <a-button type="primary" @click="switchTable('area')">区域查询</a-button>
                <a-button style="margin-left: 12px" type="primary" @click="switchTable('user')">平行大用户</a-button>
                <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>

    <!-- 表格区域 -->
    <a-card :bordered="false" class="table-card">
      <!-- 未查询时显示提示框 -->
      <div v-if="!hasQueried" class="empty-state">
        <a-icon type="search" class="empty-icon" />
        <p class="empty-text">请选择片区和查询时间后点击查询按钮</p>
        <p class="empty-hint">选择片区 → 选择查询时间 → 点击"区域查询"或"平行大用户"按钮</p>
      </div>

      <!-- 已查询时显示表格 -->
      <div v-else>
        <!-- 表格标题 -->
        <div class="table-title">
          <h3 class="title-text">
            <a-icon :type="activeTable === 'area' ? 'area-chart' : 'user'" />
            <span v-if="tableZoneName">
              {{ tableZoneName }}{{ activeTable === 'area' ? '流量表' : '平行大用户表' }}
            </span>
          </h3>
          <a-button type="primary" icon="download" :loading="exportLoading" @click="exportHandles">导出</a-button>
        </div>

        <!-- 区域查询表格 -->
        <a-table v-show="activeTable === 'area'" rowKey="id" :bordered="true"
          :row-selection="{ selectedRowKeys: this.areaSelectedRows, onChange: onAreaSelectChange }"
          :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="areaList"
          :columns="areaColumns" :loading="areaLoading" :pagination="areaPagination" @change="areaPageChange"
          :scroll="{ x: 1500 }">
        </a-table>

        <!-- 平行大用户表格 -->
        <a-table v-show="activeTable === 'user'" rowKey="id" :bordered="true"
          :row-selection="{ selectedRowKeys: this.userSelectedRows, onChange: onUserSelectChange }"
          :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="userList"
          :columns="userColumns" :loading="userLoading" :pagination="userPagination" @change="userPageChange"
          :scroll="{ x: 1500 }">
        </a-table>
      </div>
    </a-card>
  </div>
</template>

<script>
import axios from 'axios'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import moment from 'moment'

export default {
  name: 'AreaTrafficAnalysis',
  data () {
    return {
      activeTable: 'area', // 当前激活的表格：'area' 或 'user'
      selectedZoneName: '', // 选中的片区名称
      tableZoneName: '', // 表格显示的片区名称
      hasQueried: false, // 是否已经查询过
      exportLoading: false, // 导出按钮加载状态

      // 区域查询表格相关
      areaColumns: [], // 区域查询列配置
      areaList: [], // 区域查询数据
      areaLoading: false, // 区域查询加载状态
      areaSelectedRows: [], // 区域查询选中行
      areaPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },

      // 平行大用户表格相关
      userColumns: [
        { title: '平行大用户名称', dataIndex: 'userName', key: 'userName', width: 150, align: 'center' },
        { title: '用户编号', dataIndex: 'userCode', key: 'userCode', width: 120, align: 'center' },
        { title: '累积流量(m³)', dataIndex: 'accumulatedFlow', key: 'accumulatedFlow', width: 120, align: 'center' },
        { title: '查询日流量(m³)', dataIndex: 'queryDateFlow', key: 'queryDateFlow', width: 120, align: 'center' },
        { title: '前1日流量(m³)', dataIndex: 'oneDayAgo', key: 'oneDayAgo', width: 120, align: 'center' },
        { title: '前2日流量(m³)', dataIndex: 'twoDaysAgo', key: 'twoDaysAgo', width: 120, align: 'center' },
      ], // 平行大用户列配置
      userList: [], // 平行大用户数据
      userLoading: false, // 平行大用户加载状态
      userSelectedRows: [], // 平行大用户选中行
      userPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },

      query: { //查询对象
        zoneId: undefined, // 片区id
        queryDate: '', // 查询日期
      },
      queryTime: null, // 日期选择器绑定值
      queryZoneDateUrl: 'zone-metering/zone-metering',
      // 片区流量统计查询url
      queryZoneFlowDateUrl: '/zone-metering/zone-traffic-change',
      // 平行大用户查询url
      queryUserFlowDateUrl: '/zone-metering/zone-traffic-change/parallel-big-user-traffic',
      zoneTreeData: [], // 片区选项
      treeDefaultExpandedKeys: [], // 片区选项展开
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' })
    }
  },
  created () {
    this.getZoneData()
  },
  methods: {
    // 切换表格
    switchTable (type) {
      // 验证是否选择了片区
      if (!this.query.zoneId) {
        this.$message.warning('请先选择片区后再查询')
        return
      }

      // 验证是否选择了查询日期
      if (!this.query.queryDate) {
        this.$message.warning('请先选择查询时间后再查询')
        return
      }

      this.activeTable = type
      this.hasQueried = true // 标记为已查询
      this.tableZoneName = this.selectedZoneName // 更新表格显示的片区名称

      if (type === 'area') {
        this.getAreaList()
      } else if (type === 'user') {
        this.getUserList()
      }
    },

    // 获取区域查询列配置
    getAreaColumnsConfig (data) {
      return new Promise((resolve) => {
        // 如果没有数据，给个空对象防止报错
        const headerData = data || {}

        this.areaColumns = [
          {
            title: '片区名称',
            dataIndex: 'zoneName',
            key: 'zoneName',
            width: 150,
            align: 'center',
            ellipsis: true
          },
          {
            title: '前2日',
            children: [
              {
                title: headerData.twoDaysAgoDate || '-',
                dataIndex: 'twoDaysAgo',
                key: 'twoDaysAgo',
                width: 120,
                align: 'center',
                ellipsis: true
              }
            ]
          },
          {
            title: '前1日',
            children: [
              {
                title: headerData.oneDayAgoDate || '-',
                dataIndex: 'oneDayAgo',
                key: 'oneDayAgo',
                width: 120,
                align: 'center',
                ellipsis: true
              }
            ]
          },
          {
            title: '查询时间',
            className: 'column-blue',
            children: [
              {
                title: headerData.queryDateStr || '-',
                dataIndex: 'queryDateFlow',
                key: 'queryDateFlow',
                width: 120,
                align: 'center',
                ellipsis: true,
                className: 'column-blue'
              }
            ]
          },
          {
            title: '上月同期 (m³)',
            children: [
              {
                title: headerData.lastMonthSamePeriodDate || '-',
                dataIndex: 'lastMonthSamePeriod',
                key: 'lastMonthSamePeriod',
                width: 120,
                align: 'center',
                ellipsis: true
              }
            ]
          },
          {
            title: '去年同期 (m³)',
            children: [
              {
                title: headerData.lastYearSamePeriodDate || '-',
                dataIndex: 'lastYearSamePeriod',
                key: 'lastYearSamePeriod',
                width: 150,
                align: 'center',
                ellipsis: true
              }
            ]
          },
          {
            title: '前1日时变化系数 (%)',
            children: [
              {
                title: headerData.oneDayAgoDate || '-',
                dataIndex: 'oneDayAgoChangeCoefficient',
                key: 'oneDayAgoChangeCoefficient',
                width: 170,
                align: 'center',
                ellipsis: true
              }
            ]
          },
          {
            title: '当日时变化系数 (%)',
            className: 'column-blue',
            children: [
              {
                title: headerData.queryDateStr || '-',
                dataIndex: 'queryDateChangeCoefficient',
                key: 'queryDateChangeCoefficient',
                width: 170,
                align: 'center',
                ellipsis: true,
                className: 'column-blue'
              }
            ]
          },
          {
            title: '上月同期 (%)',
            children: [
              {
                title: headerData.lastMonthSamePeriodDate || '-',
                dataIndex: 'lastMonthChangeCoefficient',
                key: 'lastMonthChangeCoefficient',
                width: 120,
                align: 'center',
                ellipsis: true
              }
            ]
          },
          {
            title: '去年同期 (%)',
            children: [
              {
                title: headerData.lastYearSamePeriodDate || '-',
                dataIndex: 'lastYearChangeCoefficient',
                key: 'lastYearChangeCoefficient',
                width: 150,
                align: 'center',
                ellipsis: true
              }
            ]
          },
          {
            title: '本月累计 (m³)',
            dataIndex: 'monthAccumulated',
            key: 'monthAccumulated',
            width: 120,
            align: 'center',
            ellipsis: true
          },
          {
            title: '本年累计 (m³)',
            dataIndex: 'yearAccumulated',
            key: 'yearAccumulated',
            width: 120,
            align: 'center',
            ellipsis: true
          }
        ]
        console.log('区域查询列配置:', this.areaColumns)
        resolve()
      })
    },

    // 获取区域查询数据
    async getAreaList () {
      this.areaLoading = true
      let param = {
        ...this.query,
        onlyDirectChildren: true,
        page: this.areaPagination.current,
        limit: this.areaPagination.pageSize
      }
      try {
        const { data } = await this.$http.get(this.queryZoneFlowDateUrl, { params: param })
        // 先获取列配置，等待完成后再赋值数据
        await this.getAreaColumnsConfig(data.list[0])
        console.log('片区流量统计数据:', data)
        this.areaList = data.list
        console.log(data.total);

        this.areaPagination.total = data.total
        console.log('区域查询数据:', this.areaList)
      } catch (error) {
        console.error('获取区域查询数据失败:', error)
      } finally {
        this.areaLoading = false
      }
    },

    // 获取平行大用户数据
    getUserList () {
      this.userLoading = true
      let param = {
        ...this.query,
        page: this.userPagination.current,
        limit: this.userPagination.pageSize
      }
      this.$http.get(this.queryUserFlowDateUrl, { params: param }).then(({ data }) => {
        console.log('平行大用户数据:', data)
        this.userList = data.list
        this.userPagination.total = data.total
        console.log('平行大用户数据:', this.userList)
      }).finally(() => {
        this.userLoading = false
      })
    },

    // 区域查询表格选择变化
    onAreaSelectChange (selectedRowKeys) {
      this.areaSelectedRows = selectedRowKeys
    },

    // 平行大用户表格选择变化
    onUserSelectChange (selectedRowKeys) {
      this.userSelectedRows = selectedRowKeys
    },

    // 区域查询分页变化
    areaPageChange (pagination) {
      this.areaPagination.current = pagination.current
      this.areaPagination.pageSize = pagination.pageSize
      this.getAreaList()
    },

    // 平行大用户分页变化
    userPageChange (pagination) {
      this.userPagination.current = pagination.current
      this.userPagination.pageSize = pagination.pageSize
      this.getUserList()
    },

    // 重置
    resetList () {
      this.query = {
        zoneId: undefined,
        queryDate: ''
      }
      this.queryTime = null // 清空日期
      this.selectedZoneName = '' // 清空片区名称
      this.tableZoneName = '' // 清空表格显示的片区名称
      this.hasQueried = false // 重置查询状态
      // 重置区域查询
      this.areaPagination.current = 1
      this.areaSelectedRows = []
      this.areaList = [] // 清空表格数据
      // 重置平行大用户
      this.userPagination.current = 1
      this.userSelectedRows = []
      this.userList = [] // 清空表格数据
      this.$message.success('已重置，请重新选择片区')
    },
    // 获取采集时间
    pushOnChange () {
      if (this.pushTime && this.pushTime.length === 2) {
        this.query.currentIssueTimeBegin = this.pushTime[0].format('YYYY-MM-DD');
        this.query.currentIssueTimeEnd = this.pushTime[1].format('YYYY-MM-DD');
      }
    },
    exportHandles () {
      this.exportLoading = true
      let exportUrl = ''
      let fileName = ''

      if (this.activeTable === 'area') {
        exportUrl = 'zone-metering/zone-traffic-change/export'
        fileName = `${this.tableZoneName || ''}片区流量统计.xlsx`
      } else {
        exportUrl = 'zone-metering/zone-traffic-change/parallel-big-user-traffic/export'
        fileName = `${this.tableZoneName || ''}平行大用户统计.xlsx`
      }

      axios.get(`${process.env.VUE_APP_API_BASE_URL}${exportUrl}`, {
        params: this.query,
        responseType: 'blob',
        headers: {
          'Authorization': storage.get(ACCESS_TOKEN),
          'Accept': 'application/vnd.ms-excel'
        }
      })
        .then(response => {
          console.log('导出响应:', response);
          const blob = response.data;
          // 下载逻辑
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(url);

          this.$message.success('导出成功');
        })
        .catch(error => {
          console.log('导出失败:', error);
          this.$message.error('下载失败');
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    getZoneData () {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },

    // 禁用今天及以后的日期（只能选昨天及以前）
    disabledDate (current) {
      // current 是当前日期的 moment 对象
      // moment().subtract(1, 'days') 是昨天
      // 返回 true 表示禁用该日期
      return current && current > moment().subtract(1, 'days')
    },

    // 处理日期变化
    handleTimeChange (date, dateString) {
      console.log('选择的日期:', date, dateString)
      this.query.queryDate = dateString || ''
    },

    // 处理片区选择变化
    handleZoneChange (value, label, extra) {
      console.log('选择的片区:', value, label, extra)
      if (value) {
        // 从树形数据中查找选中的片区名称
        this.selectedZoneName = this.findZoneNameById(this.zoneTreeData, value)
      } else {
        this.selectedZoneName = ''
      }
      console.log('选中的片区名称:', this.selectedZoneName)
    },

    // 递归查找片区名称
    findZoneNameById (treeData, id) {
      for (let node of treeData) {
        if (node.id === id) {
          return node.zoneName
        }
        if (node.children && node.children.length > 0) {
          const result = this.findZoneNameById(node.children, id)
          if (result) return result
        }
      }
      return ''
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
// 查询区域样式
.search-card {
  margin-bottom: 16px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

// 表格区域样式
.table-card {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

// 空状态提示样式
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  min-height: 400px;

  .empty-icon {
    font-size: 80px;
    color: #d9d9d9;
    margin-bottom: 20px;
  }

  .empty-text {
    font-size: 18px;
    color: #595959;
    margin-bottom: 8px;
    font-weight: 500;
  }

  .empty-hint {
    font-size: 14px;
    color: #8c8c8c;
    margin: 0;
  }
}

// 表格标题样式
.table-title {
  padding: 16px 0;
  margin-bottom: 16px;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title-text {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #1890ff;
    display: flex;
    align-items: center;

    i {
      margin-right: 8px;
      font-size: 18px;
    }
  }
}

/deep/.table-striped {
  background-color: #fafafa;
}

/deep/.column-blue {
  background-color: #e6f7ff !important;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>
